import type { ArabicCatalog } from "@ncp/i18n";
import type en from "./processes.en";

/** إجراءات الإدارة خارج إجراءات الملف نفسه التي تحملها المنصة: دراسة السوق في ملفها وفتحها من إشارة سوقية، وتذكيرات التقييم اللاحق، واعتماد الإقرار السنوي للإحصاءات، واعتماد منهجية السياسات، وإرسال الرأي المعتمد. */
const ar: ArabicCatalog<typeof en> = {
  study: {
    stage: "المرحلة: {{stage}}",
    noFile: "لم تجر بعد في ملف دراسة سوق. يفتح ملفها – بالشروط المرجعية والمدد والتشاور واعتماد المدير أو الوكيل – أو تربط بملف قائم قبل أول طلب بيانات، حتى لا تصل الطلبات إلى أحد إذا كان ملف اختبار.",
    noFileSent: "لم تجر بعد في ملف دراسة سوق. يفتح ملفها، وتحفظ فيه طلبات البيانات المرسلة بالفعل.",
    noFileNotAuthorised: "لم تجر بعد في ملف دراسة سوق. يفتحه موظف مخول بموجب مصفوفة تفويض الصلاحيات.",
    openFile: "فتح ملف دراسة السوق الخاص بها",
    fileOpened: "فتح ملف دراسة السوق {{caseNumber}}.",
    requestedWithFile: "طلبت الدراسة في ملف دراسة السوق {{caseNumber}} – الوكيل يعدها الآن.",
    requestedWithoutFile: "تطلب الدراسة دون ملف دراسة السوق الخاص بها: يفتح الملف موظف مخول من الدراسة.",
    fileField: "ملف دراسة السوق",
    fileFieldHint: "تجري الدراسة في ملفها النظامي: الشروط المرجعية والمدد والتشاور واعتماد الوزارة هي مراحل الملف.",
    fileModes: { Open: "فتح ملف دراسة سوق جديد", Link: "الربط بملف دراسة سوق قائم" },
    existingFile: "الملف القائم",
    fileStudy: "دراسة السوق",
    fileNoStudy: "لم تربط بهذا الملف دراسة من بنك البيانات بعد",
  },
  exPost: {
    notAuthorised: "يقرأ بنك البيانات للتقييم وتسجل نتيجته من موظف مخول بموجب مصفوفة تفويض الصلاحيات. وتسند المهمة إلى الموظف المسؤول قبل موعد الاستحقاق بـ{{period.expost.reminderBefore}} يوما، وإلى المدير بعد انقضائه.",
  },
  statistics: {
    hiddenFiles_zero: "لا ملفات لا يمكنك فتحها",
    hiddenFiles_one: "ملف واحد لا يمكنك فتحه",
    hiddenFiles_two: "ملفان لا يمكنك فتحهما",
    hiddenFiles_few: "{{count}} ملفات لا يمكنك فتحها",
    hiddenFiles_many: "{{count}} ملفا لا يمكنك فتحها",
    hiddenFiles_other: "{{count}} ملف لا يمكنك فتحه",
    hiddenChecks_two: "تتعلق فحوص البيانات بملفين لا يمكنك فتحهما؛ وتقرأ الأرقام هذين الملفين على النحو الذي تبينه الفحوص.",
    hiddenChecks_few: "تتعلق فحوص البيانات بـ{{count}} ملفات لا يمكنك فتحها؛ وتقرأ الأرقام هذه الملفات على النحو الذي تبينه الفحوص.",
    hiddenChecks_one: "يتعلق فحص للبيانات بملف واحد لا يمكنك فتحه؛ وتقرأ الأرقام هذا الملف على النحو الذي يبينه الفحص.",
    hiddenChecks_other: "تتعلق فحوص البيانات بـ{{count}} ملف لا يمكنك فتحه؛ وتقرأ الأرقام هذه الملفات على النحو الذي تبينه الفحوص.",
    signOffs: "اعتماد الإقرارات",
    signOffHint: "بعد انقضاء السنة يعتمد إقرارها الموظف المخول – المدير فمن فوقه بموجب مصفوفة تفويض الصلاحيات. ويسجل الاعتماد الأرقام وفحوص البيانات التي أجريت؛ ثم تقفل أرقام السنة، وتعرض الجداول والمصنف الأرقام المعتمدة، إلى أن يعاد فتح السنة مع بيان الأسباب.",
    signedYear: "اعتمد إقرار {{year}} {{name}} في {{date}}",
    unsignedYear: "إقرار {{year}} غير معتمد",
    signOff: "اعتماد",
    reopen: "إعادة الفتح",
    signTitle: "اعتماد إقرار {{year}}",
    signHint: "تسجل مع اعتمادك أرقام السنة كما هي الآن وفحوص البيانات التي أجريت، ثم تقفل الأرقام.",
    reopenTitle: "إعادة فتح إقرار {{year}}",
    reopenHint: "تبقى الأرقام المعتمدة في سجل التدقيق. وبعد إعادة الفتح يجوز تصحيح أرقام السنة ثم اعتمادها من جديد.",
    note: "ملاحظة (اختيارية)",
    reasons: "سبب إعادة فتح الإقرار",
    signed: "اعتمد إقرار {{year}} وأقفلت أرقامه.",
    reopened: "أعيد فتح إقرار {{year}}.",
    lockedYear: "اعتمد في {{date}}: الأرقام مقفلة",
  },
  advocacy: {
    sendings: "الإرسال إلى الجهة المصدرة",
    sendingsHint: "كل إرسال للرأي المعتمد إلى الجهة المصدرة للتشريع كما سجله موظف مخول: الجهة المرسل إليها ويوم الإرسال وكتاب الإحالة. ولا تعد النظرة العامة مرسلا إلا الآراء المسجل إرسالها هنا.",
    notSent: "لم يسجل إرسال هذا الرأي بعد.",
    recordedBy: "سجله {{name}}",
    recordSending: "تسجيل الإرسال",
    recordHint: "يسجل الرأي مرسلا بعد وصوله إلى الجهة، مع يوم الإرسال ومرجع كتاب الإحالة أو الرسالة.",
    recipient: "أرسل إلى",
    sentOn: "تاريخ الإرسال",
    reference: "مرجع كتاب الإحالة",
    referenceHint: "المرجع الصادر من الوزارة أو الرسالة التي أرسل بها الرأي.",
    note: "ملاحظة",
    record: "تسجيل",
    sent: "سجل الإرسال إلى {{recipient}}.",
  },
  signals: {
    openStudy: "فتح دراسة سوق",
    studyTitle: "فتح دراسة سوق انطلاقا من هذه الإشارة",
    studyHint: "تطلب دراسة لسوق الإشارة في استوديو دراسات السوق وتجري في ملف دراسة سوق خاص بها يفتح الآن مع أسبابك؛ وتذكر الإشارة منطلقا لها وتوضع قيد المراجعة.",
    studyReasons: "سبب دراسة السوق",
    studyReasonsHint: "يسجل في الملف باسمك (جملة على الأقل).",
    studyOpened: "فتحت دراسة السوق في الملف {{caseNumber}}.",
    studyLink: "دراسة السوق {{caseNumber}}",
  },
};

export default ar;
